// Header Inline Search Functionality
(function() {
  class HeaderSearch {
    constructor() {
      this.init();
    }

    init() {
      // Wait for DOM to be fully loaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }

    setup() {
      // Initialize on any search-form in the header
      this.searchForms = document.querySelectorAll('.header-inline-search');
      
      if (!this.searchForms.length) return;
      
      this.searchForms.forEach(form => {
        const searchInput = form.querySelector('[data-js-search-input]');
        const resultsContainer = form.querySelector('[data-js-search-results]');
        
        if (!searchInput || !resultsContainer) return;
        
        // Setup search functionality
        this.setupSearch(searchInput, resultsContainer, form);
      });

      // Close search results when clicking outside
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.header-inline-search')) {
          this.searchForms.forEach(form => {
            const resultsContainer = form.querySelector('.header-search-results');
            if (resultsContainer) {
              resultsContainer.classList.remove('visible');
            }
          });
        }
      });
    }

    setupSearch(input, resultsContainer, form) {
      const searchUrl = KROWN.settings.routes.predictive_search_url;
      let cachedResults = {};
      let timeoutId = null;
      let a11yIndex = -1;
      let results = [];

      // Process input for search
      input.addEventListener('input', () => {
        clearTimeout(timeoutId);
        
        const query = input.value.trim();
        
        if (query.length > 0) {
          timeoutId = setTimeout(() => {
            this.performSearch(query, resultsContainer, searchUrl, cachedResults)
              .then(searchResults => {
                results = searchResults;
                a11yIndex = -1;
              });
          }, 300);
        } else {
          resultsContainer.innerHTML = '';
          form.querySelector('.header-search-results').classList.remove('visible');
        }
      });

      // Handle keyboard navigation
      input.addEventListener('keydown', (e) => {
        if (results.length === 0) return;

        // Up arrow
        if (e.keyCode === 38) {
          e.preventDefault();
          this.navigateResults('up', results, a11yIndex, (newIndex) => { a11yIndex = newIndex; });
        }
        // Down arrow
        else if (e.keyCode === 40) {
          e.preventDefault();
          this.navigateResults('down', results, a11yIndex, (newIndex) => { a11yIndex = newIndex; });
        }
        // Enter
        else if (e.keyCode === 13 && a11yIndex >= 0 && results[a11yIndex]) {
          e.preventDefault();
          const item = results[a11yIndex];
          const link = item.tagName === 'A' ? item.href : item.querySelector('a')?.href;
          if (link) {
            window.location.href = link;
          }
        }
        // Escape
        else if (e.keyCode === 27) {
          form.querySelector('.header-search-results').classList.remove('visible');
          input.blur();
        }
      });

      // Show results when input is focused
      input.addEventListener('focus', () => {
        if (input.value.trim().length > 0 && resultsContainer.innerHTML.trim()) {
          form.querySelector('.header-search-results').classList.add('visible');
        }
      });
    }

    async performSearch(query, resultsContainer, searchUrl, cachedResults) {
      // Show loading state
      resultsContainer.innerHTML = KROWN.settings.predictive_search_placeholder || '<div class="search-loading">Loading...</div>';
      
      const searchResultsContainer = resultsContainer.closest('.header-search-results');
      if (searchResultsContainer) {
        searchResultsContainer.classList.add('visible');
      }

      // Check cache first
      const cacheKey = query.toLowerCase().replace(/\s+/g, '-');
      if (cachedResults[cacheKey]) {
        resultsContainer.innerHTML = cachedResults[cacheKey];
        return Array.from(resultsContainer.querySelectorAll('[data-js-search-item]'));
      }

      // Otherwise fetch from Shopify
      try {
        const response = await fetch(`${searchUrl}?q=${encodeURIComponent(query)}&section_id=helper-predictive-search`);
        
        if (!response.ok) {
          throw new Error(`Search request failed: ${response.status}`);
        }
        
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const content = doc.querySelector('#shopify-section-helper-predictive-search').innerHTML;
        
        resultsContainer.innerHTML = content;
        cachedResults[cacheKey] = content;
        
        return Array.from(resultsContainer.querySelectorAll('[data-js-search-item]'));
      } catch (error) {
        console.error('Search error:', error);
        resultsContainer.innerHTML = '<div class="search-error">Sorry, there was an error with your search.</div>';
        return [];
      }
    }

    navigateResults(direction, results, currentIndex, setIndex) {
      if (!results.length) return;
      
      // Remove active class from current item
      if (currentIndex >= 0 && results[currentIndex]) {
        results[currentIndex].classList.remove('active');
      }
      
      // Calculate new index
      let newIndex;
      if (direction === 'up') {
        newIndex = currentIndex <= 0 ? results.length - 1 : currentIndex - 1;
      } else {
        newIndex = currentIndex >= results.length - 1 ? 0 : currentIndex + 1;
      }
      
      // Set active class on new item
      if (results[newIndex]) {
        results[newIndex].classList.add('active');
        
        // Scroll into view if needed
        const container = results[newIndex].closest('[data-js-search-results-holder]') || 
                          results[newIndex].closest('.header-search-results');
        
        if (container) {
          const itemTop = results[newIndex].offsetTop;
          const containerScrollTop = container.scrollTop;
          const containerHeight = container.clientHeight;
          
          if (itemTop < containerScrollTop) {
            container.scrollTop = itemTop;
          } else if (itemTop + results[newIndex].clientHeight > containerScrollTop + containerHeight) {
            container.scrollTop = itemTop + results[newIndex].clientHeight - containerHeight;
          }
        }
      }
      
      // Update index
      setIndex(newIndex);
    }
  }

  // Initialize the component
  new HeaderSearch();
})();